import {
  faArrowsAltH,
  faExternalLinkAlt,
  faSearchMinus,
  faSearchPlus,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';

const Toolbar = ({
  title,
  onClose,
  onZoomIn,
  onZoomOut,
  onFit,
  fitToWidth,
  onExternal,
  showZoomControls = true,
}) => {
  return (
    <div className='dv-header'>
      <div className='dv-title' title={title}>
        {title || 'Document'}
      </div>
      <div className='dv-actions'>
        {showZoomControls && (
          <>
            <button type='button' className='dv-icon-button' title='Zoom out' onClick={onZoomOut}>
              <FontAwesomeIcon icon={faSearchMinus} />
            </button>
            <button type='button' className='dv-icon-button' title='Zoom in' onClick={onZoomIn}>
              <FontAwesomeIcon icon={faSearchPlus} />
            </button>
            <button
              type='button'
              className='dv-icon-button'
              title={fitToWidth ? 'Disable fit to width' : 'Fit to width'}
              onClick={onFit}
            >
              <FontAwesomeIcon icon={faArrowsAltH} />
            </button>
          </>
        )}
        <button
          type='button'
          className='dv-icon-button'
          title='Open in new tab'
          onClick={onExternal}
        >
          <FontAwesomeIcon icon={faExternalLinkAlt} />
        </button>
        <button type='button' className='dv-icon-button' title='Close' onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>
    </div>
  );
};

Toolbar.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onZoomIn: PropTypes.func,
  onZoomOut: PropTypes.func,
  onFit: PropTypes.func,
  fitToWidth: PropTypes.bool,
  onExternal: PropTypes.func.isRequired,
  showZoomControls: PropTypes.bool,
};

Toolbar.defaultProps = {
  title: null,
  onZoomIn: () => {},
  onZoomOut: () => {},
  onFit: () => {},
  fitToWidth: false,
  showZoomControls: true,
};

export default Toolbar;
